import React from 'react'
import { WidgetHOC, WidgetProps } from './WidgetHOC'

const CtaContainer = React.lazy(() => import('@features/cta/CTA').then(m => ({ default: m.CTA })))

export const CtaWidget: React.FC<WidgetProps> = props => {
  const { widgetContext } = props
  return (
    <WidgetHOC widgetContext={widgetContext}>
      <CtaContainer />
    </WidgetHOC>
  )
}
